<ng-template #content>
    <ng-content select="[label]"></ng-content>
</ng-template>
<ng-template #prefixIcon>
    <ng-content select="[prefixIcon]"></ng-content>
</ng-template>
